import React from 'react'

import _ from 'lodash'

import {IconButton, Modal, ModalHeader, ModalActions, S1, S2, Button, SortableList, indexId, Popup, P, Colors} from '../../UI/index.js'
import askToSaveChanges from '../../UI/overlays/askToSaveChanges.js'
import CarrierLogo from '../../parcels/CarrierLogo.js'
import {Input} from '../../UI/forms/index.js'

import PreferenceModal from '../../modals/PreferenceModal.js'
import Countries from '../../../utils/Countries.js'

export default class ParcelReferenceModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            show: false,
            error: ''
        }

        this.state = structuredClone(this.initialState)
    }

    open(preferences) {
        this.setState({show: true, preferences})
    }

    async close(showWarning) {
        if (showWarning) {
            const choice = await askToSaveChanges(this.popup)

            if (choice === 'save') {
                this.onSubmit()
            } else if (choice === 'dontSave') {
                this.setState(this.initialState)
            }
        } else {
            this.setState(this.initialState)
        }
    }

    onClickAddPreference(productName) {
        const {preferences} = this.state

        const preference = {name: '', countries: []}
        preferences[productName] = preferences[productName] || []
        preferences[productName].push(preference)

        this.setState({preferences})

        this.onClickOpenPreferenceModal(productName, preferences[productName].length - 1, preference)
    }

    onClickOpenPreferenceModal(productName, index, preference) {
        const {preferences} = this.state
        const {products} = this.props

        let countries = products[productName].countries

        if (countries.length > 1) {
            countries.push('Overige')
        }

        const usedCountries = []
        preferences[productName].map((preference) => {
            usedCountries.push(...preference.countries)
        })

        countries = _.uniq(_.difference(countries, usedCountries))
        countries.push(...preference.countries)

        countries.sort((a, b) => {
            const countryA = _.find(Countries, {code2: a}) || {code2: a, name: a}
            const countryB = _.find(Countries, {code2: b}) || {code2: b, name: b}
            return countryA.name.localeCompare(countryB.name)
        })
        const otherIndex = countries.indexOf('Overige')
        if (otherIndex > -1) {
            countries.splice(otherIndex, 1)
            countries.push('Overige')
        }

        this.PreferenceModal.open(productName, index, preference, countries)
    }

    onEditPreference(productName, index, preference) {
        const {preferences} = this.state

        preferences[productName][index] = preference

        this.setState({preferences})
    }

    onRemovePreference(productName, index) {
        const {preferences} = this.state

        preferences[productName].splice(index, 1)

        this.setState({preferences})
    }

    onChangePreference(productName, index, carrierName, event) {
        const {preferences} = this.state
        const preference = event.target.value.toUpperCase()

        if (!preference || /^[0-9 X]$/.test(preference)) {
            preferences[productName][index][carrierName] = preference

            this.setState({preferences})
        }
    }

    onSortPreferences(productName, productPreferences) {
        const {preferences} = this.state

        preferences[productName] = productPreferences

        this.setState({preferences})
    }

    onSubmit() {
        const {preferences} = this.state
        const {onChange, reseller} = this.props

        reseller.settings.parcels.preferences = preferences

        onChange(reseller, 'parcels.preferences')
        this.close()
    }

    render() {
        const {show} = this.state
        const {enabledCarriers, carriers, products, reseller} = this.props

        return (
            <Modal style={{width: 'fit-content', maxWidth: '95%', height: 'fit-content', maxHeight: '95%', overflowY: 'auto', display: 'flex', flexDirection: 'column'}} show={show} onClose={this.close.bind(this, true)}>
                <ModalHeader title='Wijzig voorkeuren' onClose={this.close.bind(this, true)} style={{marginBottom: 0}} />

                <div style={{flex: 1, overflowY: 'auto', marginBottom: 12}}>
                    <div style={{display: 'flex', paddingLeft: 300, position: 'sticky', top: 0, zIndex: 10, backgroundColor: Colors.backgroundNeutral, width: 'fit-content'}}>
                        {enabledCarriers.map((carrier) => {
                            return (
                                <div
                                    key={`header${carrier.name}`}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        marginRight: 12,
                                        minWidth: 90,
                                        width: 90
                                    }}
                                >
                                    <CarrierLogo
                                        size={45}
                                        carriers={carriers}
                                        value={carrier.name}
                                    />
                                    <P style={{width: 90, textAlign: 'center'}}>{carrier.displayName || carrier.name}{carrier.platform ? ` - ${carrier.platform}` : ''}</P>
                                </div>
                            )
                        })}
                    </div>

                    {_.keys(products).map((productName) => {
                        if (products[productName].carriers.length > 0) {
                            return (
                                <div key={productName} style={{marginBottom: 12}}>
                                    <S1 style={{marginBottom: 12}}>{productName}</S1>

                                    {reseller.settings.parcels.preferences[productName] &&
                                        <SortableList
                                            dragHandle
                                            getId={indexId}
                                            // Block, like the list before: the items' bottom margins collapse with the spacing around it
                                            style={{display: 'block'}}
                                            items={reseller.settings.parcels.preferences[productName]}
                                            renderItem={(preference, DragHandle, index) => {
                                                return (
                                                    <div key={`${productName}${index}`} style={{display: 'flex', marginLeft: 15, marginBottom: 12}}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: 285,
                                                            minWidth: 285,
                                                            height: 30
                                                        }}
                                                        >
                                                            <DragHandle />
                                                            <IconButton onClick={this.onClickOpenPreferenceModal.bind(this, productName, index, preference)}>
                                                                <i className='mdi mdi-pencil' />
                                                            </IconButton>
                                                            <S2>{preference.name}</S2>
                                                        </div>

                                                        {enabledCarriers.map((carrier) => {
                                                            const carrierHasProduct = products[productName].carriers.indexOf(carrier.name) > -1
                                                            const carrierHasCountry = carrierHasProduct && (preference.countries.indexOf('Overige') > -1 || _.intersection(carrier.combinedProducts[productName], preference.countries).length > 0)

                                                            return (
                                                                <Input
                                                                    key={`carriers${carrier.name}`}
                                                                    style={{
                                                                        marginRight: 12,
                                                                        width: 90
                                                                    }}
                                                                    disabled={!carrierHasCountry}
                                                                    value={carrierHasCountry ? (preference[carrier.name] || '') : ''}
                                                                    onChange={this.onChangePreference.bind(this, productName, index, carrier.name)}
                                                                />
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            }}
                                            onChange={this.onSortPreferences.bind(this, productName)}
                                        />
                                    }

                                    <Button
                                        variant='outline-white'
                                        style={{marginBottom: 24, width: 'fit-content'}}
                                        icon='mdi mdi-plus'
                                        label='Nieuwe landengroep'
                                        onClick={this.onClickAddPreference.bind(this, productName)}
                                    />
                                </div>
                            )
                        }
                    })}
                </div>

                <ModalActions>
                    <Button variant='text' onClick={this.close.bind(this, true)}>Annuleer</Button>
                    <Button variant='text' onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>

                <PreferenceModal
                    onChange={this.onEditPreference.bind(this)}
                    remove={this.onRemovePreference.bind(this)}
                    ref={(ref) => this.PreferenceModal = ref}
                />

                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}
